import { ref, onMounted, onBeforeUnmount } from 'vue'

/**
 * Cattura `beforeinstallprompt` (Chromium) e lo differisce per offrire una
 * CTA "Installa" controllata dall'app. La UI la monta solo il pubblico.
 */
export function usePwaInstall () {
  const deferredPrompt = ref(null)
  const canInstall = ref(false)

  function onBeforeInstallPrompt (e) {
    e.preventDefault()
    deferredPrompt.value = e
    canInstall.value = true
  }

  function onAppInstalled () {
    deferredPrompt.value = null
    canInstall.value = false
  }

  onMounted(() => {
    window.addEventListener('beforeinstallprompt', onBeforeInstallPrompt)
    window.addEventListener('appinstalled', onAppInstalled)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('beforeinstallprompt', onBeforeInstallPrompt)
    window.removeEventListener('appinstalled', onAppInstalled)
  })

  async function promptInstall () {
    if (!deferredPrompt.value) return
    deferredPrompt.value.prompt()
    await deferredPrompt.value.userChoice
    deferredPrompt.value = null
    canInstall.value = false
  }

  return { canInstall, promptInstall }
}
